<template>
  <div class="credit-cell-renderer">
    <div v-if="params.value">
      <el-button
          v-if="params.data.entityType === 'account' || params.data.entityType === 'sub-account'"
          size="mini"
          @click="openGenerallLedgerDetailedModal(params)">
        {{formatPrice(params.data.credit ? params.data.credit : 0)}}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "creditCellRenderer",
  methods: {
    openGenerallLedgerDetailedModal(params) {
      if (params.data.DRCRCode === 'CR') this.params.context.componentParent.openGenerallLedgerDetailedModal(params)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>

<style lang="less" scoped>
.credit-cell-renderer {
  width:100%;
  padding:0 5px;
  button {
    width: 100%;
    text-align: right;
    display:flex;
    justify-content: flex-end;
  }
}
</style>
